import styled from 'styled-components';

export const PaymentInfoContainer = styled.div`
	border-radius: 4px;
	border: 1px solid #141414;
	padding: 2rem;
	background-color: #fff;
`;

export const PaymentInfoTitle = styled.h5`
	font-size: 1.5rem;
	margin-bottom: 2rem;
`;

export const PaymentInfoSubTitle = styled.h5`
	font-weight: 500;
	font-size: 1.1rem;
	margin: 0;
	padding: 0;
`;
